export const GoogleMapApiConfig = 'AIzaSyAXUmuie98IwEMv_20fiNuWXdg3HcP1W0c';